import YouTubePlayer from 'youtube-player';
class IframeYoutube extends HTMLElement {
  constructor() {
    self = super();
    // Always call super first in constructor
    // Return value from super() is a reference to this element

    this.classList.add('media')
    this.videoId = this.getAttribute('video-id')
    this.videoKey = this.getAttribute('video-key')
    this.defaultCover = this.getAttribute('default-cover')
    this.posterUrl = 'https://img.youtube.com/vi/' + this.videoId + '/maxresdefault.jpg'
    
    this.posterMarkup = `<div class="iframe__poster figure figure-gradient">
      <img
        src="${this.posterUrl}"
        width="1280"
        height="720"
        alt="Poster"
        class="iframe__img"
        loading="lazy">
      <button
        class="button iframe__play"
        type="button"
        value="Play Youtube Video"
      >
        <i class="icon icon-play">
          <svg viewBox="0 0 23 26" xmlns="http://www.w3.org/2000/svg">
            <path d="M23 13L0.500001 25.9904L0.500002 0.00961778L23 13Z" fill="white"/>
          </svg>
        </i>
        <span class="visually-hidden">Play Youtube Video</span>
      </button>
    </div>`;

    // Create a shadow root
    // const shadow = this.attachShadow({mode: 'open'});
    
    const iframeContainer = document.createElement('div');
    iframeContainer.setAttribute('class', 'iframe-container');

    // Create player element
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', `player-${this.videoKey}`);
    iframeContainer.appendChild(wrapper);

    iframeContainer.insertAdjacentHTML("beforeend", this.posterMarkup)

    this.appendChild(iframeContainer);

    this.player = YouTubePlayer(wrapper, {
      videoId: this.videoId,
      playerVars: {
        rel: 0
      }
    });

    this.playButton = this.querySelector(".iframe__play")
    this.poster = this.querySelector(".iframe__poster")

    this.playButton.addEventListener("click", evt => {
      evt.preventDefault()
      this.poster.classList.add("iframe__poster--playing")
      this.player.playVideo()
    })

    this.player.on('stateChange', (evt) => {
      if (evt.data === 0) {
        this.poster.classList.remove("iframe__poster--playing")
      }
    })
  
    this.calculateSize(this.posterUrl)
      .then(data => {
        if (data.width === 120 && data.height === 90) {
          iframeContainer.querySelector(".iframe__img").src = this.defaultCover
        }
      })
      .catch((error) => {
        console.error(error)
      })
  
  }
  
  calculateSize(url) {
    return new Promise(function(resolve, reject) {
      const image = document.createElement('img');
      image.addEventListener('load', function(e) {
        resolve({
          width: e.target.width,
          height: e.target.height,
        });
      });
      
      image.addEventListener('error', function() {
        reject('error');
      });
      
      image.src = url;
    });
  }
}

export default IframeYoutube
